export default `
	query GetPrice($weight: Float!, $term: Int!) {
		getPrice(weight: $weight, term: $term) {
			id
			weight
			cost
			price
			term
			type
			status
			meta {
				key
				margin
				percent
				subscriptionCost
				subscriptionPrice
			}
		}
	}
`;
